// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as RescriptReactRouter from "../../../../../../node_modules/@rescript/react/src/RescriptReactRouter.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as TrustAndSafetyAssetsManager from "../assets/TrustAndSafetyAssetsManager.bs.js";

var listIcon = TrustAndSafetyAssetsManager.getImage("list-icon.svg");

var banIcon = TrustAndSafetyAssetsManager.getImage("ban-icon.svg");

var walletIcon = TrustAndSafetyAssetsManager.getImage("wallet-icon.svg");

function getFeatureRoute(feature) {
  switch (feature) {
    case /* BulkSuspensions */0 :
        return "/tns/bulk/suspensions";
    case /* PartnerBlacklist */1 :
        return "/tns/partner/blacklist";
    case /* WalletWithdrawalBlock */2 :
        return "/tns/wallet/withdrawal/block";
    
  }
}

function TrustAndSafetySidebar(Props) {
  var activeFeature = Props.activeFeature;
  var sidebarItems_0 = [
    /* BulkSuspensions */0,
    "Bulk Suspensions",
    listIcon
  ];
  var sidebarItems_1 = {
    hd: [
      /* PartnerBlacklist */1,
      "Partner Blacklist/Whitelist",
      banIcon
    ],
    tl: {
      hd: [
        /* WalletWithdrawalBlock */2,
        "Wallet Withdrawal Block",
        walletIcon
      ],
      tl: /* [] */0
    }
  };
  var sidebarItems = {
    hd: sidebarItems_0,
    tl: sidebarItems_1
  };
  return React.createElement("div", {
              className: "c-blacklist-partner-page__sidebar"
            }, React.createElement("div", {
                  className: "c-blacklist-partner-page__sidebar-section"
                }, React.createElement("div", {
                      className: "c-blacklist-partner-page__sidebar-heading"
                    }, "PARTNER ACTIONS"), ReasonReactUtils$Catalyst.listToReactArray(List.mapi((function (index, param) {
                            var feature = param[0];
                            var isActive = activeFeature === feature;
                            return React.createElement("div", {
                                        key: String(index),
                                        className: "c-blacklist-partner-page__sidebar-item" + (
                                          isActive ? " c-blacklist-partner-page__sidebar-item--active" : ""
                                        ),
                                        onClick: (function (param) {
                                            return RescriptReactRouter.push(getFeatureRoute(feature));
                                          })
                                      }, React.createElement("img", {
                                            className: "c-blacklist-partner-page__sidebar-icon",
                                            alt: "",
                                            src: param[2]
                                          }), React.createElement("span", undefined, param[1]));
                          }), sidebarItems))));
}

var make = TrustAndSafetySidebar;

export {
  listIcon ,
  banIcon ,
  walletIcon ,
  getFeatureRoute ,
  make ,
  
}
/* listIcon Not a pure module */
